export default __webpack_public_path__ + "static/media/480px-Loader.c4cee91c.gif";